import * as React from 'react';
import classNames from 'classnames';

import * as styles from './LegalDocumentsLayout.css';
import * as gridStyles from '../../utils/grid.css';

export const LegalDocumentsLayout: React.FC = ({ children }) => (
  <div className={classNames(styles['c-footer-legal'], gridStyles['cg-col-24'])}>
    <noindex>{children}</noindex>
  </div>
);
